module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /var/www/svea-ostosraha-fi/web/app/themes/opr-ostosraha/node_modules/axios/index.js
// module id = 307
// module chunks = 0